module.exports = __webpack_public_path__ + "static/media/streak-book.241c16a0.png";